import { AsyncPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AssetsState } from '../../states/assets.state';

@Component({
  selector: 'rk-asset-dynamic-mock',
  templateUrl: './asset-dynamic-mock.component.html',
  styleUrl: './asset-dynamic-mock.component.scss',
  standalone: true,
  imports: [AsyncPipe],
})
export class AssetDynamicMockComponent {
  @Input() assetMainColor = '#000000';
  @Input() assetKey: string;
  @Select(AssetsState.logoURL) logoURL$: Observable<string>;
  @Select(AssetsState.iconTvURL) iconTvURL$: Observable<string>;
  @Select(AssetsState.smartphoneSplashscreenURL) smartphoneURL$: Observable<string>;
  @Select(AssetsState.smartphoneLargeSplashscreenURL)
  smartphoneLargeURL$: Observable<string>;
  @Select(AssetsState.tvSplashscreenURL) tvSplashscreenURL$: Observable<string>;
  @Select(AssetsState.topShelfTvURL) topShelfTvURL$: Observable<string>;
}
